var React = require('react');

function DonatechartInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"donut-hole","cx":"21","cy":"21","r":"15.91549430918954","fill":"transparent","key":0}),React.createElement("circle",{"className":"donut-ring","cx":"21","cy":"21","r":"15.91549430918954","fill":"transparent","stroke":"rgba(0,0,0,0.3)","strokeWidth":"3","key":1}),React.createElement("circle",{"className":"donut-segment","cx":"21","cy":"21","r":"15.91549430918954","fill":"transparent","stroke":"#d6d6d6","strokeWidth":"3","strokeDasharray":"85 15","strokeDashoffset":"25","key":2})]);
}

DonatechartInline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 42 42","className":"donut"};

module.exports = DonatechartInline;

DonatechartInline.default = DonatechartInline;
